export enum ShowedContentType {
	'skeleton' = 'skeleton',
	'error' = 'error',
	'content' = 'content'
}
